import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import About4 from './../Elements/About4';
import Specialization4 from './../Elements/Specialization4';
import Document from './../Elements/Document';
import OurMission from '../Elements/OurMission';

var bnrimg = require('./../../images/about-banner.jpg');

class About extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Committed to accurate inspections, dedicated to stronger communities." pagename="About Us" bgimage={bnrimg}/>
                    <About4 />
                    <Document />   
                    <OurMission />
                    <Specialization4 />
                    {/* <Team3 />    */}
                </div>
                <Footer />
            </>
        );
    };
};

export default About;